<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { ElMessageBox } from 'element-plus'
import { useAppStore } from '@/store/modules/app'
import { changeTextSizeFn, changeColorFn } from '@/libs/utils/theme-fn'
const appStore = useAppStore()
const locale = ref(zhCn)
changeTextSizeFn(appStore.size)
changeColorFn(appStore.theme)
</script>
<style lang="scss" scoped></style>
